module.exports = __webpack_public_path__ + "static/media/Proxima_Nova_Bold.62d4d7d3.otf";